import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const LegalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: "24px",
      borderRadius: "15px",
    },
    toolTip: {
      "&.MuiTooltip-popper": {
        position: "relative",
        zIndex: "99999999999999",
        // border: "1px solid red",
      },
    },
    modalMessage: {
      color: theme.palette.text.disabled,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "16px",
      marginBottom: "24px",
    },
    legalModalGrid: {
      padding: "2rem 1.5em",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "100vh",
      alignItems: "center",
      maxWidth: "900px",
      [theme.breakpoints.up("md")]: {
        height: "90vh",
      },
    },
    modalTitle: {
      display: "flex",
      alignItems: "center",
      fontSize: "2rem",
      fontWeight: "Bold",

      [theme.breakpoints.up("md")]: {
        fontSize: "2.5rem",
      },
    },

    buttonWrapper: {
      width: "100%",
      display: "flex",
    },

    scollBar: {
      overflowX: "hidden",
      overflowY: "scroll",
      margin: "1rem 0",
      padding: "0 0.5rem",
      maxWidth: "876px",
      flex: "1",
      [theme.breakpoints.up("md")]: {
        margin: "1.5rem 0",
        padding: "0 0.5rem",
      },
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "rgba(200, 200, 200, 0.5)",
      },
      "&::-webkit-scrollbar-thumb": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "rgb(200, 200, 200)",
      },
    },
  }),
);
